import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/dpdk.webp';
import screenshot_target from '../../../images/letterfunnel/pimvanhelten.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Pim van Helten"
      firstname="Pim"
      companyname="DPDK"
      competition="Dept Agency en Fabrique"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pimvanhelten.js